import { createSelector } from 'reselect';
export const hashedAddresses = state => state.addresses;
export const allAddresses = createSelector(
    hashedAddresses,
    addresses => Object.keys(addresses).map(hashKey => addresses[hashKey])
);
export const hasAddresses = createSelector(
    allAddresses,
    addresses => addresses.length > 0
);
export const addressForHash = (state, addressHash) => hashedAddresses(state)[addressHash];
